import { TextLink } from "../../../../components/link/TextLink";
import {
  INSTAGRAM,
  LINKED_IN,
  TIKTOK,
  YOUTUBE,
} from "../../../../constants/links";
import { linksContainer } from "./styles.css";

export const LinksBlock = () => {
  return (
    <div className={linksContainer}>
      <span>Find us on </span>
      <TextLink isExternal to={LINKED_IN}>
        LinkedIn
      </TextLink>
      <span>, </span>
      <TextLink isExternal to={YOUTUBE}>
        YouTube
      </TextLink>
      <span>, </span>
      <TextLink isExternal to={TIKTOK}>
        TikTok
      </TextLink>
      <span>, </span>
      <span>and&nbsp;</span>
      <TextLink isExternal to={INSTAGRAM}>
        Instagram
      </TextLink>
    </div>
  );
};
